import React, { useEffect, useState, useRef } from "react";
import "../../assets/css/Services.css";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

// meta data
import { Helmet } from "react-helmet";
import data from "../../component/ApiUrl/meta_api";

/* ─── Data ─────────────────────────────────────────────────────────────────── */
const SERVICES = [
  {
    icon: "fa-microchip",
    title: "Embedded Systems Development",
    desc: "We develop high-performance embedded systems for industrial applications including automation, control systems, and real-time processing. Our solutions ensure reliability, scalability, and efficient operation in mission-critical environments.",
  },
  {
    icon: "fa-industry",
    title: "IIoT (Industrial IoT) Solutions",
    desc: "Implement Industrial IoT (IIoT) solutions for smart manufacturing, machine connectivity, and real-time data monitoring. We enable industries to improve efficiency, reduce downtime, and optimize operations with connected systems.",
  },
  {
    icon: "fa-microchip",
    title: "PCB Design & Industrial Prototyping",
    desc: "We offer robust PCB design and prototyping services for industrial-grade applications, ensuring durability, high performance, and long-term reliability in harsh environments.",
  },
  {
    icon: "fa-code",
    title: "Firmware & RTOS Development",
    desc: "Our team develops optimized firmware and RTOS-based solutions for microcontrollers and embedded processors, ensuring seamless integration, real-time control, and system stability.",
  },
  {
    icon: "fa-gears",
    title: "Industrial Automation Integration",
    desc: "Integrate embedded systems with PLC, SCADA, and industrial automation systems to enable real-time monitoring, process control, and smart factory implementation.",
  },
  {
    icon: "fa-chart-line",
    title: "IIoT Data Analytics & Predictive Maintenance",
    desc: "Leverage IIoT data analytics to monitor equipment performance, predict failures, and reduce downtime. Our solutions enable predictive maintenance and data-driven decision making for industries.",
  },
];

const TABS = [
  {
    tabs: "Embedded Systems",
    label: "Design & Development",
    icon: "fa-microchip",
    image: require("../../assets/img/Service/Embadded Sytem Service/card-1.jpg"),
    content:
      "We design and develop robust embedded systems from concept to production — delivering reliable firmware, hardware, and microcontroller-based solutions for real-world applications.",
    features: [
      "Firmware & Microcontroller Programming",
      "ARM & RTOS Development",
      "PCB Design & Prototyping",
      "Prototype to Production Support",
    ],
  },

  {
    tabs: "IIoT",
    label: "Connectivity & Integration",
    icon: "fa-network-wired",
    image: require("../../assets/img/Service/Embadded Sytem Service/card-2.jpg"),
    content:
      "Connect your industrial devices, machines, and systems seamlessly to the cloud with our end-to-end IIoT integration services built for smart manufacturing environments.",
    features: [
      "Device-to-Cloud Connectivity",
      "MQTT & OPC-UA Protocol Integration",
      "Gateway & Edge Device Setup",
      "Cloud Platform Integration (AWS/Azure)",
    ],
  },

  {
    tabs: "Analytics",
    label: "Smart Monitoring & Prediction",
    icon: "fa-chart-line",
    image: require("../../assets/img/Service/Embadded Sytem Service/card-3.jpg"),
    content:
      "Transform raw industrial data into actionable insights with our smart monitoring dashboards and AI-powered predictive analytics for proactive maintenance and decision-making",
    features: [
      "Real-Time Dashboard Development",
      "Predictive Maintenance Systems",
      "AI-Driven Fault Detection",
      "Machine Health & KPI Tracking",
    ],
  },

  {
    tabs: "Automation & Control",
    label: "Industrial Automation & Control Systems",
    icon: "fa-gears",
    image: require("../../assets/img/Service/Embadded Sytem Service/card-4.jpg"),
    content:
      "Build smarter factories with our integrated industrial automation and control solutions — combining PLC, SCADA, HMI, and robotics for a fully connected production environment",
    features: [
      "PLC Programming & Integration",
      "HMI Design & Development",
      "Smart Factory & Industry 4.0",
      "System Commissioning & Support",
    ],
  },

  {
    tabs: "Wireless & Sensor Networks",
    label: "Wireless Sensor & Network Solutions",
    icon: "fa-wifi",
    image: require("../../assets/img/Service/Embadded Sytem Service/card-5.jpg"),
    content:
      "Deploy intelligent wireless sensor networks across your facility to enable seamless communication, remote monitoring, and real-time data collection without complex wiring.",
    features: [
      "Wireless Sensor Networks (WSN)",
      "Modbus & Profibus Integration",
      "Modbus & Profibus Integration",
      "Remote Asset Monitoring",
    ],
  },

  {
    tabs: "Digital Twin & Energy Systems",
    label: "Digital Twin & Energy Optimization",
    icon: "fa-cube",
    image: require("../../assets/img/Service/Embadded Sytem Service/card-6.jpg"),
    content:
      "Create virtual replicas of your physical assets and optimize energy usage with our digital twin technology — enabling simulation, testing, and continuous performance improvement.",
    features: [
      "Digital Twin Implementation",
      "Energy Monitoring & Optimization",
      "Simulation & Virtual Testing",
      "Continuous Performance Improvemen",
    ],
  },
];

const STEPS = [
  {
    icon: "fa-magnifying-glass",
    title: "Requirement Analysis & System Planning",
    desc: "Analyze industrial processes and machines to identify automation and IIoT opportunities.",
  },
  {
    icon: "fa-lightbulb",
    title: "Embedded System & Architecture Design",
    desc: "Design scalable embedded systems, PCB, firmware, and IIoT architecture.",
  },
  {
    icon: "fa-microchip",
    title: "Firmware Development & Integration",
    desc: "Develop firmware and integrate systems with sensors, PLC, SCADA, networks.",
  },
  {
    icon: "fa-network-wired",
    title: "IIoT Deployment & Cloud Integration",
    desc: "Enable device connectivity, real-time data transfer, and cloud integration.",
  },
  {
    icon: "fa-gauge-high",
    title: "Monitoring, Analytics & Optimization",
    desc: "Implement dashboards, predictive maintenance, and analytics to improve system efficiency.",
  },
];

const BENEFITS = [
  {
    icon: "fa-microchip",
    title: "Custom Embedded Systems",
    desc: "Design and development of high-performance embedded systems for industrial automation, smart devices, and real-time control applications.",
  },
  {
    icon: "fa-network-wired",
    title: "IIoT Solutions",
    desc: "Industrial IoT integration with secure device connectivity, cloud platforms, and real-time data communication for smart manufacturing.",
  },
  {
    icon: "fa-diagram-project",
    title: "Industrial Automation",
    desc: "Automation using PLC, SCADA, sensors, and embedded controllers to improve efficiency, accuracy, and reduce manual operations.",
  },
  {
    icon: "fa-chart-line",
    title: "Real-Time Monitoring",
    desc: "Monitor machine performance, production data, and system health with real-time dashboards and analytics.",
  },
  {
    icon: "fa-shield-halved",
    title: "Secure & Scalable Systems",
    desc: "Build secure embedded solutions with scalable architecture and reliable communication protocols for future expansion.",
  },
  {
    icon: "fa-gears",
    title: "End-to-End Development",
    desc: "Complete solution from PCB design and firmware development to deployment, testing, and ongoing support.",
  },
];

const FAQ_DATA = [
  [
    "What Embedded Systems and IIoT services do you offer?",
    "We provide complete Embedded Systems Development and Industrial IoT (IIoT) solutions including PCB design, firmware development, sensor integration, industrial automation, cloud connectivity, and real-time monitoring systems for smart industries.",
  ],
  [
    "How can IIoT solutions improve my business operations?",
    "IIoT solutions enable real-time data monitoring, predictive maintenance, and automation of industrial processes. This helps reduce downtime, improve efficiency, and optimize overall productivity in manufacturing and industrial environments.",
  ],
  [
    "Do you develop custom embedded systems?",
    "Yes, we design and develop custom embedded systems tailored to your specific industrial requirements, including microcontroller-based systems, IoT devices, and real-time control applications.",
  ],
  [
    "What industries do you support with Embedded Systems and IIoT?",
    "We serve industries like manufacturing, energy, agriculture, automotive, healthcare, and smart infrastructure by providing industrial automation and IoT-based smart solutions.",
  ],
  [
    "Do you provide PCB design and firmware development?",
    "Yes, we offer end-to-end services including PCB design, circuit development, embedded firmware programming, and hardware-software integration for industrial and IoT applications.",
  ],
  [
    "What is included in your Industrial Automation solutions?",
    "Our industrial automation services include PLC programming, SCADA integration, sensor connectivity, machine automation, and system optimization to improve operational efficiency.",
  ],
  [
    "How long does it take to develop an embedded system or IIoT solution?",
    "The development timeline depends on project complexity. Basic embedded systems may take a few weeks, while advanced IIoT and industrial automation solutions can take several months including design, development, and deployment.",
  ],
  [
    "Do you provide real-time monitoring and analytics?",
    "Yes, we develop real-time monitoring dashboards with data analytics, enabling businesses to track machine performance, energy usage, and system health remotely.",
  ],
  [
    "Are your IIoT systems secure and scalable?",
    "Yes, we build secure and scalable IIoT systems using industry-standard protocols, encrypted communication, and cloud-based architecture to ensure data safety and future expansion.",
  ],
  [
    "How can I get started with your Embedded Systems and IIoT services?",
    "You can contact us for a free consultation. We will analyze your requirements, suggest the best embedded and IIoT solutions, and provide a customized development plan.",
  ],
];

/* ─── Small components ──────────────────────────────────────────────────────── */
function SectionLabel({ text }) {
  return (
    <p
      className="fw-semibold text-uppercase mb-1"
      style={{ fontSize: 20, color: "#cc0000", letterSpacing: 1 }}
    >
      {text}
    </p>
  );
}

function FAQItem({ q, a, idx }) {
  const [open, setOpen] = useState(idx === 0);
  return (
    <div
      className={`rs-faq-item rs-anim${open ? " open" : ""}`}
      style={{ transitionDelay: `${idx * 55}ms` }}
    >
      <button className="rs-faq-btn" onClick={() => setOpen((o) => !o)}>
        <span className="rs-faq-q">{q}</span>
        <span className="rs-faq-icon">
          <i className="fa-solid fa-plus" />
        </span>
      </button>
      <div className="rs-faq-body">{a}</div>
    </div>
  );
}

/* ─── Main Page ─────────────────────────────────────────────────────────────── */
export default function EmbaddedSystem() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [meta, setMeta] = useState(null);

  const fetchData = () => {
    const EmbaddedSystemMeta = data[0]?.embedded_systems_page;
    if (EmbaddedSystemMeta) {
      setMeta(EmbaddedSystemMeta);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-in-out",
    });

    if (!document.getElementById("rs-styles")) {
      const s = document.createElement("style");
      s.id = "rs-styles";
      document.head.appendChild(s);
    }
    if (!document.querySelector('link[href*="font-awesome"]')) {
      const fa = document.createElement("link");
      fa.rel = "stylesheet";
      fa.href =
        "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css";
      document.head.appendChild(fa);
    }
    if (!document.querySelector('link[href*="Poppins"]')) {
      const gf = document.createElement("link");
      gf.rel = "stylesheet";
      gf.href =
        "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap";
      document.head.appendChild(gf);
    }
  }, []);

  const tab = TABS[activeTab];

  return (
    <div className="body">
      <Helmet>
        <title>{meta ? meta.title : "Embedded Systems"}</title>
      </Helmet>
      {/* ═════════
          1. HERO 
      ═════════════ */}
      <div
        className="backgroundCommenImage position-relative d-flex align-items-center mb-5"
        style={{
          backgroundImage: `url(${require("../../assets/img/Service/Embadded Sytem Service/embadded-system-banner.jpg")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "60vh",
        }}
      >
        {/* Overlay */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{ background: "rgba(0, 0, 0, 0.75)", zIndex: 1 }}
        ></div>

        {/* Content */}
        <div
          className="container position-relative text-center text-white py-4 py-md-5"
          style={{ zIndex: 2 }}
        >
          {/* Badge */}
          <span
            className="fw-semibold d-inline-block mb-3 px-3 py-1 rounded-pill"
            style={{
              background: "#cc0000",
              fontSize: "clamp(10px,3vw,12px)",
              letterSpacing: "0.5px",
            }}
            data-aos="fade-down"
            data-aos-delay="100"
          >
            ✦ Embedded Systems · IIoT · PLC · SCADA · Industrial Automation
          </span>

          {/* Heading */}
          <h1
            className="fw-semibold mb-3"
            style={{
              fontSize: "clamp(18px,5vw,28px)",
              lineHeight: 1.4,
            }}
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Embedded Systems & IIoT Services
            <br />
            <span style={{ color: "#cc0000" }}>
              Smart Manufacturing · PCB Design · Firmware · Industry 4.0
              Solutions
            </span>
          </h1>

          {/* Text */}
          <p
            className="mx-auto mb-4 px-2 px-md-0"
            style={{
              fontSize: "clamp(13px,3.5vw,15px)",
              maxWidth: "650px",
              lineHeight: 1.7,
              color: "#ebe6e6",
            }}
            data-aos="fade-up"
            data-aos-delay="350"
          >
            End-to-end Embedded Systems & IIoT services: hardware design, PCB,
            firmware, automation, smart manufacturing, real-time monitoring,
            predictive maintenance.
          </p>
        </div>
      </div>

      {/* ════════════
          2. INTRO — 
      ═════════════════ */}
      <div className="container margin_top container_width">
        <div className="row align-items-center justify-content-center g-5">
          {/* Left */}
          <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
            <SectionLabel text="Embedded Systems & IIoT Services" />

            <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
              Advanced Embedded Systems & IIoT Solutions for Smart Industries
            </h2>

            <p className="mb-3" style={{ fontSize: 15 }}>
              <span className="fw-semibold">Skimitar Hindustan Pvt Ltd</span>{" "}
              delivers cutting-edge Embedded Systems and Industrial IoT (IIoT)
              Services designed to help industries build intelligent, connected,
              and automated systems. Our expertise includes embedded hardware
              design, industrial PCB development, firmware programming, and
              IIoT-based automation solutions tailored for manufacturing and
              industrial environments.
            </p>

            <p className="mb-3" style={{ fontSize: 15 }}>
              In today's Industry 4.0 landscape, businesses require smart and
              connected solutions to improve operational efficiency, enable
              real-time monitoring, and reduce downtime. We provide end-to-end
              development from concept to deployment, ensuring scalable,
              reliable, and high-performance embedded systems with seamless
              industrial connectivity.
            </p>

            <ul className="list-unstyled mt-3">
              {[
                "Custom Embedded Systems Development for industrial automation and IIoT applications",
                "Industrial-grade PCB Design and Prototyping for harsh environments",
                "Firmware & RTOS Development for real-time control and processing",
                "IIoT Integration for machine connectivity and real-time monitoring",
                "Predictive Maintenance solutions to reduce downtime and improve efficiency",
                "Scalable and reliable systems for smart manufacturing and Industry 4.0",
              ].map((item, i) => (
                <li
                  key={i}
                  className="d-flex align-items-start gap-2 mb-2 small"
                  data-aos="fade-up"
                  data-aos-delay={`${100 + i * 80}`}
                >
                  <i className="fa-solid fa-check text-danger mt-1"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right */}
          <div
            className="col-lg-6 text-center"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <div className="position-relative d-inline-block w-100">
              {/* Image */}
              <img
                className="img-fluid rounded-4"
                src={require("../../assets/img/Service/Embadded Sytem Service/dm-1.jpg")}
                alt="Embedded Systems and IIoT Services"
              />

              {/* Stat */}
              <div className="retro-stat">
                <i className="fa-solid fa-industry text-danger fs-5"></i>
                <div>
                  <div className="fw-bold fs-5">150+</div>
                  <div className="small text-muted">
                    Embedded & IIoT Projects Delivered
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ════════════════
          3. OUR SERVICES
      ════════════════════ */}
      <section className="margin_top py-5 bg-light">
        <div className="container container_width">
          <div className="mb-2" data-aos="fade-up">
            <SectionLabel text="Our Embedded Systems & IIoT Services" />
          </div>

          <div className="row align-items-center mb-5">
            <div
              className="col-lg-6"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <h2 className="fw-semibold" style={{ fontSize: 20 }}>
                Advanced Embedded Systems & IIoT Solutions for Smart Industries
              </h2>

              <p className="mb-3" style={{ fontSize: 15 }}>
                From embedded hardware design to Industrial IoT (IIoT)
                integration, we deliver end-to-end solutions that enable smart
                manufacturing, real-time monitoring, and data-driven industrial
                automation.
              </p>
            </div>

            <div
              className="col-lg-6 text-lg-end mt-3 mt-lg-0"
              data-aos="fade-left"
              data-aos-delay="100"
            >
              <a href="#contact" className="btn btn-danger px-4 py-2">
                Get Industrial Solution
                <i className="fa-solid fa-arrow-right ms-2"></i>
              </a>
            </div>
          </div>

          {/* Cards */}
          <div className="row g-3">
            {SERVICES.map((s, i) => (
              <div
                key={i}
                className="col-12 col-sm-6 col-lg-4"
                data-aos="fade-up"
                data-aos-delay={`${i * 100}`}
              >
                <div className="card h-100 border-0 shadow service-card">
                  <div className="card-body position-relative p-4">
                    {/* Number */}
                    <span className="service-number">
                      {String(i + 1).padStart(2, "0")}
                    </span>

                    {/* Icon */}
                    <div className="service-icon mb-3">
                      <i className={`fa-solid ${s.icon}`}></i>
                    </div>

                    <h5 className="fw-bold mb-2" style={{ fontSize: 15 }}>
                      {s.title}
                    </h5>

                    <p className="small text-muted mb-0">{s.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════════
          4. SERVICE DETAILS — tabs + feature list
      ══════════════════════════════════════════════════════════════ */}
      <section className="margin_top pb-5">
        <div className="container container_width">
          <div className="mb-1" data-aos="fade-up">
            <SectionLabel text="Embadded System & IIOT Service Details" />
          </div>

          <div className="row mb-4">
            <div className="col-lg-7" data-aos="fade-up" data-aos-delay="100">
              <h2 className="fw-semibold mb-2" style={{ fontSize: 20 }}>
                What Our Embedded Systems & IIoT Services Deliver
              </h2>

              <p className="mb-3" style={{ fontSize: 15 }}>
                With{" "}
                <span className="fw-semibold">Skimitar Hindustan Pvt Ltd</span>,
                you get advanced Embedded Systems and IIoT solutions combining
                hardware design, firmware, industrial automation, and real-time
                data analytics to improve efficiency, enable smart
                manufacturing, and reduce downtime.
              </p>
            </div>
          </div>

          {/* Tabs */}
          <div
            className="d-flex justify-content-center flex-wrap gap-2 mb-5"
            data-aos="fade-up"
            data-aos-delay="150"
          >
            {TABS.map((t, i) => (
              <button
                key={i}
                className={`btn btn-sm rounded-4 ${
                  activeTab === i ? "btn-danger" : "btn-outline-secondary"
                }`}
                onClick={() => setActiveTab(i)}
              >
                <i className={`fa-solid ${t.icon} me-2`} />
                {t.tabs}
              </button>
            ))}
          </div>

          {/* Content */}
          <div className="row align-items-center g-5">
            {/* Image */}
            <div
              className="col-lg-5 justify-content-center"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <img
                src={tab.image}
                alt={tab.label}
                className="img-fluid rounded-4"
              />
            </div>

            {/* Text Content */}
            <div className="col-lg-7" data-aos="fade-left" data-aos-delay="200">
              <SectionLabel text={tab.label} />

              <p className="mb-3" style={{ fontSize: 15 }}>
                {tab.content}
              </p>

              {/* Features */}
              <div>
                {tab.features.map((f, i) => (
                  <div
                    key={i}
                    className="d-flex align-items-start border-bottom py-3"
                    data-aos="fade-up"
                    data-aos-delay={`${i * 80}`}
                  >
                    <div className="feature-dot me-3">
                      <i className="fa-solid fa-check"></i>
                    </div>

                    <span className="fw-medium small">{f}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════════
          5. HOW IT WORKS — 5-step process
      ══════════════════════════════════════════════════════════════ */}
      <section className="margin_top py-5 bg-light" id="process">
        <div className="container container_width">
          <div className="mb-2" data-aos="fade-up">
            <SectionLabel text="How It Works" />
          </div>

          <div className="mb-5" data-aos="fade-up" data-aos-delay="100">
            <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
              Our Embedded Systems & IIoT Development Workflow
            </h2>

            <p className="mb-3" style={{ fontSize: 15 }}>
              We follow a structured embedded systems and Industrial IoT (IIoT)
              development process to deliver scalable, reliable, and
              high-performance solutions. From requirement analysis to
              deployment and optimization, our approach ensures seamless
              integration of hardware, firmware, cloud connectivity, and
              industrial automation systems. This helps businesses achieve smart
              manufacturing, real-time monitoring, predictive maintenance, and
              improved operational efficiency.
            </p>
          </div>

          <div className="row g-4 text-center justify-content-center">
            {STEPS.map((step, i) => (
              <div
                key={i}
                className="col-6 col-md-4 col-lg position-relative"
                data-aos="fade-up"
                data-aos-delay={`${i * 120}`}
              >
                {/* connector */}
                {i < STEPS.length - 1 && (
                  <div className="process-line d-none d-lg-block"></div>
                )}

                {/* circle */}
                <div className="process-circle mx-auto mb-3 d-flex align-items-center justify-content-center position-relative">
                  <i className={`fa-solid ${step.icon} text-red fs-5`}></i>

                  <span className="badge bg-red position-absolute process-number">
                    {i + 1}
                  </span>
                </div>

                <h5 className="fw-bold small mb-1">{step.title}</h5>

                <p className="text-muted small mb-0">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════════
          6. WHY CHOOSE US — left content + right grid
      ══════════════════════════════════════════════════════════════ */}
      <section className="margin_top pb-5" id="why">
        <div className="container container_width">
          <div className="row align-items-start g-5 justify-content-center">
            {/* Left */}
            <div
              className="col-lg-5 rs-anim-l"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <SectionLabel text="Why Choose Us" />
              <h2 className="fw-semibold mb-3" style={{ fontSize: 22 }}>
                The Embedded Systems & IIoT Advantage
              </h2>

              <p className="mb-3" style={{ fontSize: 15 }}>
                5+ Years Experience · Embedded Systems Development · Industrial
                Automation · IIoT Solutions · PCB Design · Firmware Development
                · Smart Manufacturing · Real-Time Monitoring · Predictive
                Maintenance · Cloud & Edge Integration
              </p>
              <div className="rs-quote-box">
                <p>
                  "Implementing their embedded systems and IIoT solutions
                  transformed our industrial operations. We achieved real-time
                  monitoring, reduced downtime, and improved overall
                  productivity through automation and predictive maintenance."
                </p>
                <span>— Plant Manager, Manufacturing Industry, Tamil Nadu</span>
              </div>
            </div>

            {/* Right */}
            <div className="col-lg-7">
              <div className="row g-3">
                {BENEFITS.map((b, i) => (
                  <div
                    key={i}
                    className="col-12 col-sm-6 rs-anim"
                    style={{ transitionDelay: `${i * 80}ms` }}
                    data-aos="fade-up"
                    data-aos-delay={`${i * 100}`}
                  >
                    <div className="rs-benefit-item">
                      <div className="rs-icon-box">
                        <i className={`fa-solid ${b.icon}`} />
                      </div>
                      <div>
                        <div className="rs-benefit-title">{b.title}</div>
                        <div className="rs-benefit-desc">{b.desc}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════════
          7. FAQ
      ══════════════════════════════════════════════════════════════ */}
      <section className="margin_top pb-5 rs-bg-alt" id="faq">
        <div className="container container_width py-5">
          <div className="text-center rs-anim mb-1" data-aos="fade-up">
            <SectionLabel text="FAQ" />
          </div>
          <div
            className="text-center rs-anim mb-5"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <h2 className="fw-semibold" style={{ fontSize: 20 }}>
              Embedded Systems & IIoT – Frequently Asked Questions
            </h2>
            <p className="mb-3" style={{ fontSize: 15 }}>
              Everything you need to know about our Embedded Systems
              Development, Industrial IoT (IIoT) Solutions, Industrial
              Automation, PCB Design, Firmware Development, and Smart
              Manufacturing services.
            </p>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-9">
              {FAQ_DATA.map(([q, a], i) => (
                <FAQItem key={i} q={q} a={a} idx={i} />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════════
          8. GET IN TOUCH — CTA
      ══════════════════════════════════════════════════════════════ */}
      <section style={{ marginTop: "100px" }}>
        <div className="p-5" style={{ background: "#cc0000" }}>
          <div
            className="d-flex align-items-center justify-content-center gap-3 mb-3"
            data-aos="fade-down"
          >
            <div
              className="bg-light"
              style={{ width: "40px", height: "1px" }}
            />
            <span
              className="text-uppercase fw-semibold text-white text-opacity-75"
              style={{
                letterSpacing: "2px",
                whiteSpace: "nowrap",
                fontSize: "13px",
              }}
            >
              Transform Your Industry with IIoT
            </span>
            <div
              className="bg-light"
              style={{ width: "40px", height: "1px" }}
            />
          </div>

          <div className="row g-4 align-items-center">
            <div
              className="col-lg-7 text-center text-lg-start"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <h2 className="fw-bolder text-white text-uppercase mb-3">
                Build Smart Systems with <br />
                Embedded & IIoT Experts
              </h2>

              <p
                className="text-white text-opacity-75 mb-0"
                style={{ lineHeight: "1.75" }}
              >
                Upgrade your business with advanced Embedded Systems and
                Industrial IoT (IIoT) solutions. We help industries implement
                automation, real-time monitoring, predictive maintenance, and
                smart manufacturing systems using cutting-edge technologies, PCB
                design, and firmware development.
              </p>
            </div>

            <div className="col-lg-5" data-aos="fade-left" data-aos-delay="200">
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-end">
                <button
                  className="btn oc-btn-white px-4 py-3 fw-bold text-uppercase"
                  onClick={() => navigate("/contact")}
                >
                  Get Free Consultation →
                </button>

                <a
                  className="btn oc-btn-ghost px-4 py-3 fw-bold text-uppercase"
                  href="tel:8428010909"
                >
                  📞 (+91) 8428010909
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
